import { Link } from "react-router-dom";

const FooterThree = () => {
  return (
    <footer className='footer bg-neutral-900 position-relative z-1'>
      <img
        src='assets/images/shapes/shape2.png'
        alt=''
        className='shape five animation-scalation'
      />
      <img
        src='assets/images/shapes/shape6.png'
        alt=''
        className='shape one animation-scalation'
      />
      <div className='py-120'>
        <div className='container container-two'>
          <div className='row gy-5 justify-content-center'>
            {/* Layanan Kami Column */}
            <div
              className='col-lg-4 col-md-6 col-sm-6'
              data-aos='fade-up'
              data-aos-duration={400}
            >
              <div className='footer-item'>
                <h4 className='footer-item__title fw-medium text-white mb-32'>
                  Layanan Kami
                </h4>
                <ul className='footer-menu'>
                  <li className='mb-16'>
                    <Link
                      to='/services/skripsi'
                      className='text-white hover-text-main-600 hover-text-decoration-underline transition-all'
                    >
                      <i className='ph ph-file-text me-2'></i>
                      Skripsi
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/services/tesis'
                      className='text-white hover-text-main-600 hover-text-decoration-underline transition-all'
                    >
                      <i className='ph ph-book me-2'></i>
                      Tesis
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/services/disertasi'
                      className='text-white hover-text-main-600 hover-text-decoration-underline transition-all'
                    >
                      <i className='ph ph-graduation-cap me-2'></i>
                      Disertasi
                    </Link>
                  </li>
                  <li className='mb-16'>
                    <Link
                      to='/services/jurnal'
                      className='text-white hover-text-main-600 hover-text-decoration-underline transition-all'
                    >
                      <i className='ph ph-article me-2'></i>
                      Jurnal
                    </Link>
                  </li>
                  <li className='mb-0'>
                    <Link
                      to='/services/pengolahan-data'
                      className='text-white hover-text-main-600 hover-text-decoration-underline transition-all'
                    >
                      <i className='ph ph-chart-bar me-2'></i>
                      Pengolahan Data
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Hubungi Kami Column */}
            <div
              className='col-lg-4 col-md-6 col-sm-6'
              data-aos='fade-up'
              data-aos-duration={600}
            >
              <div className='footer-item'>
                <h4 className='footer-item__title fw-medium text-white mb-32'>
                  Hubungi Kami
                </h4>
                <div className='footer-contact-info'>
                  <div className='flex-align gap-16 mb-20'>
                    <span className='icon d-flex text-24 text-main-600 flex-shrink-0'>
                      <i className='ph ph-whatsapp' />
                    </span>
                    <div>
                      <Link
                        to='https://wa.me/6283131487736'
                        className='text-white d-block hover-text-main-600 mb-0 transition-all'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        +62831 3148 7736
                      </Link>
                      <small className='text-neutral-300'>Chat WhatsApp</small>
                    </div>
                  </div>
                  <div className='flex-align gap-16 mb-20'>
                    <span className='icon d-flex text-24 text-main-600 flex-shrink-0'>
                      <i className='ph ph-envelope-open' />
                    </span>
                    <div>
                      <Link
                        to='mailto:viberesearchsolutions@gmail.com'
                        className='text-white d-block hover-text-main-600 mb-0 transition-all'
                      >
                        viberesearchsolutions@gmail.com
                      </Link>
                      <small className='text-neutral-300'>Email</small>
                    </div>
                  </div>
                  <div className='flex-align gap-16 mb-20'>
                    <span className='icon d-flex text-24 text-main-600 flex-shrink-0'>
                      <i className='ph ph-globe' />
                    </span>
                    <div>
                      <Link
                        to='https://viberesearchsolutions.com'
                        className='text-white d-block hover-text-main-600 mb-0 transition-all'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        viberesearchsolutions.com
                      </Link>
                      <small className='text-neutral-300'>Website</small>
                    </div>
                  </div>
                  <div className='flex-align gap-16 mb-0'>
                    <span className='icon d-flex text-24 text-main-600 flex-shrink-0'>
                      <i className='ph ph-map-pin' />
                    </span>
                    <div>
                      <p className='text-white mb-0 lh-sm'>
                        Desa/Kelurahan Pleret,<br />
                        Kec. Pleret, Kab. Bantul,<br />
                        Provinsi Daerah Istimewa Yogyakarta
                      </p>
                      <small className='text-neutral-300'>Alamat</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className='container'>
        <div className='bottom-footer border-top border-dashed border-neutral-600 border-0 py-32'>
          <div className='container container-two'>
            <div className='bottom-footer__inner flex-between gap-16 flex-wrap'>
              <p className='text-white text-line-1 fw-normal' data-aos='zoom-in'>
                Copyright © 2025{" "}
                <span className='fw-semibold'>Vibe Research</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
